import { useCallback, useContext } from "react";
import { ProfileContext } from "../context";
import { useConfigurationModule } from "../../Settings/Configuration/hooks/useConfigurationModule";

export const useIsActionDisabled = () => {
    const { user } = useContext(ProfileContext);
    const config = useConfigurationModule("peopleApiConnection");

    const getIsActionDisabled = useCallback((key) => {
        const values = Object.values(config?.[key] || {});
        const allFalse = values.length > 0 && values.every((item) => item === false);
        return user?.isApi && allFalse;
    }, [config, user?.isApi]);

    return getIsActionDisabled;
}
